export default (obj: Record<string, any>) =>
  Object.getPrototypeOf(obj) === Object.prototype &&
  Object.getOwnPropertyNames(obj).length === 0 &&
  Object.getOwnPropertySymbols(obj).length === 0;
